module.exports = __webpack_public_path__ + "7689df48cdffc4bb357998ec309ef54e.svg";